<script setup lang="ts" generic="T extends string">
defineProps<{ modelValue: T; options: { value: T; label: string }[] }>();
defineEmits<{ 'update:modelValue': [value: T] }>();
</script>

<template>
  <div class="seg">
    <button
      v-for="o in options"
      :key="o.value"
      :class="['seg__btn', { 'seg__btn--active': o.value === modelValue }]"
      @click="$emit('update:modelValue', o.value)"
    >
      {{ o.label }}
    </button>
  </div>
</template>

<style scoped>
.seg {
  display: flex;
  background: var(--bg-elevated);
  padding: 4px;
  border-radius: var(--r-md);
  gap: 4px;
}
.seg__btn {
  flex: 1;
  padding: 8px 12px;
  border-radius: var(--r-sm);
  color: var(--text-secondary);
  font-size: var(--fs-sm);
  font-weight: 500;
}
.seg__btn--active {
  background: var(--bg-overlay);
  color: var(--text-primary);
}
</style>
